import React from 'react';
import ConfigureMailServerModalAsync from '@jira/admin-pages__configure-mail-server-modal/src/async.tsx';
import type { Props as AppProps } from '@jira/admin-pages__configure-mail-server-modal/src/ui/types.tsx';
import type { ModalProps } from '../../types.tsx';

type Props = AppProps & ModalProps;

const ConfigureMailServerModal = (props: Props) => {
	const { onClose, action, id, name, authenticationType } = props;
	return (
		<ConfigureMailServerModalAsync
			onClose={onClose}
			action={action}
			id={id}
			name={name}
			authenticationType={authenticationType}
		/>
	);
};

export default ConfigureMailServerModal;
